import '@updater-components/tooltip';
import template from './preview.html';
import { shareOnFacebook } from './facebook';
import { shareOnTwitter } from './twitter';
import { getPublicUrl } from '../share-move.utils';
import { actions, selectors } from '../../../../state';
import { STATES } from '../../../../constants';
import './preview.global.css';

const SUBTITLE_HTML = `
  Love it? Scroll down to share with friends. <br />Needs more work?
  <a
    ui-sref="${STATES.STEP_SHARE_MOVE_CUSTOMIZE}"
    analytics-on
    analytics-event="Clicked Edit Share Announcement CTA"
  >
    Return to Editing
  </a>
`;

class ShareMovePreviewController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, {
      headerSubtitle: SUBTITLE_HTML,
      updStore,
    });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
    this.updStore.dispatch(actions.step.isTerminalRoute());
  }

  $onDestroy() {
    this.disconnect();
  }

  get publicUrl() {
    return getPublicUrl(this.item.code);
  }

  shareOnFacebook() {
    const success = response => {
      if (response) {
        this.updStore.dispatch(
          actions.analytics.track('Created Facebook Share Announcement')
        );
      }
    };

    shareOnFacebook(this.publicUrl, success);
  }

  shareOnTwitter() {
    shareOnTwitter({
      url: this.publicUrl,
      title: this.item.subject,
    });
  }
}

export const ShareMovePreviewComponent = {
  template,
  controller: ShareMovePreviewController,
};

function mapStateToThis(state) {
  const { current, move } = selectors;
  const item = current.shareMoveItem(state);
  const itemMove = move.byId(item.moveId(state));
  const siteConfig = current.siteConfig();

  return {
    userFirstName: current.user(state).firstName(state),
    company: siteConfig.company(state),
    entities: siteConfig.brandedEntities(state),
    item: {
      subject: item.subject(state),
      message: item.message(state),
      code: item.code(state),
      mainImage: item.mainImage(state),
      fromAddress: itemMove.fromAddress(state),
      toAddress: itemMove.toAddress(state),
    },
  };
}
